import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '#/components/ui/carousel';
import { useCallback } from 'react';

import type { CampaignInfoV2, CampaignSearchResponseV2 } from '~/api/v2/mall/campaign/search';
import type { CommonDataResponseV2 } from '~/api/v2/mall/common-data';
import type { SegmentResponseV2 } from '~/api/v2/mall/segment';
import { DATA_AREAS } from '~/constants/data-areas';
import { CampaignCard, type CampaignCardStyles } from '~/ui/campaign-card';
import type { CampaignLogoStyles } from '~/ui/campaign-logo';
import { tw } from '~/utils';

import { SitePointupCarouselPoint } from './point/site-pointup-carousel-point';

type Props = {
  commonData: CommonDataResponseV2;
  segment?: Promise<SegmentResponseV2>;
  campaignSearch: CampaignSearchResponseV2;
};

export const SitePointupCarousel = (props: Props) => {
  // NOTE: segmentは将来的にポイント表示のパーソナライゼーションに使用予定
  const { commonData, segment: _segment, campaignSearch } = props;

  if (!commonData) return null;
  if (!campaignSearch) return null;

  const renderPoint = useCallback((item: CampaignInfoV2) => <SitePointupCarouselPoint campaign={item} />, []);

  const campaignLogoStyles = tw<CampaignLogoStyles>({
    box: 'mx-auto flex aspect-square h-full max-h-[115px] w-full max-w-[115px] place-content-center',
    img: 'object-contain',
  });

  const campaignItemStyles = tw<CampaignCardStyles>({
    box: 'border-grey-100 rounded-sm border-2 border-solid px-2 pb-3 shadow-[0px_0px_15px_#dcdcdc]',
    layout: 'grid gap-3',
    name: 'text-body-s-bold line-clamp-1 text-center break-all',
    logo: campaignLogoStyles,
    pointSlot: '',
  });

  return (
    <div data-area={DATA_AREAS.SITE_POINTUP_CAROUSEL}>
      <Carousel
        className="md:mx-auto md:max-w-[1160px] md:px-4"
        opts={{
          dragFree: true,
        }}>
        <CarouselContent className="gap-2 px-4 py-3 md:ml-0 md:px-2 lg:gap-4">
          {campaignSearch.campaign_info.map((item) => (
            <CarouselItem
              key={item.campaign_id}
              className="flex-[0_0_115px] pl-0 md:flex-[0_0_211px] md:basis-[calc(20%-6px)] lg:basis-[calc(20%-13px)] [&:first-child]:ml-4 md:[&:first-child]:ml-0 [&:last-child]:mr-4 md:[&:last-child]:mr-0 md:[&:last-child]:pr-4">
              <CampaignCard
                key={item.campaign_id}
                campaignInfo={item}
                styles={campaignItemStyles}
                renderPoint={() => renderPoint(item)}>
                {item.achievement_point_id && Number(item.achievement_point_id) > 0 && (
                  <span className="text-caption-s row-[3/4] line-clamp-1 text-center">
                    {commonData.achievement_point[item.achievement_point_id]?.name}
                  </span>
                )}
              </CampaignCard>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious button="kabuand" className="left-0 hidden h-12 w-12 md:block lg:-left-2" />
        <CarouselNext button="kabuand" className="right-0 hidden h-12 w-12 md:block lg:-right-2" />
      </Carousel>
    </div>
  );
};
